import React, { useEffect, useState } from 'react'

import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Grid } from '@mui/material'

import DashboardNavbar from '../../Components/DashboardNavbar/DashboardNavbar'
import GroupsList from '../../Components/GroupFormationComponents/GroupsList';
import GroupStats from '../../Components/GroupFormationComponents/GroupStats';
import LoadingModal from '../../Components/Modals/LoadingModal';
import SavedRunModal from '../../Components/Modals/SaveRunModal';
import SavedGroupFormationModal from '../../Components/Modals/SavedGroupFormationModal';
import ConfirmModal from '../../Components/Modals/ConfirmModal';

function GroupFormation() {
  const { state } = useLocation();
  var selectedClass;
  selectedClass = state.class_id;
  const navigate = useNavigate();

  const [groups, setGroups] = useState([]);
  const [stats, setStats] = useState([]);
  const [studentDetails, setStudentDetails] = useState([]);
  const [studentRankings, setStudentRankings] = useState();
  const [projectRankings, setProjectRankings] = useState();
  const [completed, setCompleted] = useState([]); // list of students that have completed assignment1 
  const [incomplete, setIncomplete] = useState([]); // list of students that have not completed assignment1
  // Need to figure out a way to better manage the list of students and their information
  
  const [savedRunsData, setSavedRunsData] = useState([]);
  const [lockedList, setLockedList] = useState([]); 
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showSavedList, setShowSavedList] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  
  const [ expandAll, setExpandAll ] = useState(true);

  const saveGroups = async (runName, runNotes) => {
    await axios.post(`${process.env.REACT_APP_API_HOST}/api/groups/saveRun/${state.class_id}`, 
    {
      groups: groups,
      stats: stats,
      runName: runName,
      runNotes: runNotes,
      locked_list: lockedList
    }, 
    {
      headers: {Authorization: `Bearer ${state.token.access_token}`}
    });

    setShowSaveModal(false);
  }

  const loadPageData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}/api/class/getAssignment1/${state.class_id}`,
      {
        headers: {Authorization: `Bearer ${state.token.access_token}`}
      });
      const students = response.data;
      setStudentDetails(students);
      setIncomplete(students.filter((student) => !student.studentRankingInfo?.is_completed));
      setCompleted(students.filter((student) => student.studentRankingInfo?.is_completed));
    }
    catch (error) {
      console.log(error);
    }

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}/api/ranking/getClassRankings/${selectedClass}`, 
      {
        headers: {Authorization: `Bearer ${state.token.access_token}`}
      });
      const rankings = response.data;
      let [studentRankings, projectRankings] = sortStudentRankings(rankings);
      setStudentRankings(studentRankings);
      setProjectRankings(projectRankings);
    }
    catch (error) {
      console.log(error);
    }

    if (window.sessionStorage.getItem("groups" + state.class_id))
      setGroups(JSON.parse(window.sessionStorage.getItem("groups" + state.class_id)));
    if (window.sessionStorage.getItem("locked" + state.class_id))
      setLockedList(JSON.parse(window.sessionStorage.getItem("locked" + state.class_id)));
    if (window.sessionStorage.getItem("locked" + state.class_id))
      setStats(JSON.parse(window.sessionStorage.getItem("stats" + state.class_id)));

    setLoading(false);
  }

  function sortStudentRankings(rankings) {
    let studentRankings = new Map();
    let projectRankings = new Map();
    rankings.forEach(ranking => {
      if (studentRankings.has(ranking.user.user_id))
        studentRankings.get(ranking.user.user_id).set(ranking.project.project_id, ranking.ranking)
      else {
        let projectRanking = new Map();
        projectRanking.set(ranking.project.project_id, ranking.ranking);
        studentRankings.set(ranking.user.user_id, projectRanking);
      }

      if (projectRankings.has(ranking.project.project_id))
        if (projectRankings.get(ranking.project.project_id)[ranking.ranking])
          projectRankings.get(ranking.project.project_id)[ranking.ranking].push(ranking.user);
        else {
          projectRankings.get(ranking.project.project_id)[ranking.ranking] = [];
          projectRankings.get(ranking.project.project_id)[ranking.ranking].push(ranking.user);
        }
      else {
        let userRankings = [];
        userRankings[ranking.ranking] = []
        userRankings[ranking.ranking].push(ranking.user);
        projectRankings.set(ranking.project.project_id, userRankings);
      }
    });
    return [studentRankings, projectRankings];
  }

  const handleExpandAll = () => {
    setExpandAll(true)

  }
  const handleCollapseAll = () => {
    setExpandAll(false)
  }

  const handleRunAlgorithm = async () => {
    setLoading(true);
    const response = await axios.post(`${process.env.REACT_APP_API_HOST}/api/algorithm/formGroups/${state.class_id}`,
    {fixedStudents: lockedList}, 
    {
      headers: {Authorization: `Bearer ${state.token.access_token}`}
    });

    setGroups(response.data.groups);
    setStats(response.data.stats);
    window.sessionStorage.setItem("groups" + state.class_id, JSON.stringify(response.data.groups));
    window.sessionStorage.setItem("locked" + state.class_id, JSON.stringify(lockedList));
    window.sessionStorage.setItem("stats" + state.class_id, JSON.stringify(response.data.stats));
    setLoading(false);
  }

  const handleSortByFirstChoice = async () => {
    setLoading(true);
    const response = await axios.get(`${process.env.REACT_APP_API_HOST}/api/projects/getAllForClass/${state.class_id}`, 
      {
        headers: {Authorization: `Bearer ${state.token.access_token}`}
      }
    );
    var foundUsers = [];
    let projectGroups = response.data;
    projectGroups.forEach(project => {
      project["users"] = projectRankings.has(project.project_id) && projectRankings.get(project.project_id)[1]
      ? projectRankings.get(project.project_id)[1]: []
      foundUsers.push(...project.users)
    })

    var remainingStudents = [...studentDetails]
    foundUsers.map(user => {
      remainingStudents = remainingStudents.filter(student => student.user_id !== user.user_id);
    })
    
    // check for students in the list and the students that arent in the found studetns list get added to the remaining students
    const Unsorted = {
      project_id: 0,
      name: 'Unsorted Students',
      users: remainingStudents,
    }

    projectGroups.unshift(Unsorted)

    setGroups(projectGroups);
    setStats({'total projects' : projectGroups.length})
    window.sessionStorage.setItem("groups" + state.class_id, JSON.stringify(projectGroups));
    window.sessionStorage.setItem("stats" + state.class_id, JSON.stringify({'total projects' : projectGroups.length}));
    setLoading(false);
  }

  const handleOpenSavedList = async() => {
    const response = await axios.get(`${process.env.REACT_APP_API_HOST}/api/groups/getSavedRuns/${state.class_id}`, 
    {
      headers: {Authorization: `Bearer ${state.token.access_token}`}
    });
    setSavedRunsData(response.data.savedRunsData);
    setShowSavedList(true);
  }

  const loadSavedGroups = async (run_id) => {
    setLoading(true);
    const response = await axios.get(`${process.env.REACT_APP_API_HOST}/api/groups/getSavedGroups/${run_id}`, 
    {
      headers: {Authorization: `Bearer ${state.token.access_token}`}
    });
    let run = response.data.savedGroups;
    setGroups(run.data);
    setStats(run.stats);
    setLockedList(run.locked_list);

    setShowSavedList(false);
    setLoading(false);
  }

  const handleFinalizeGroups = async () => {
    setConfirmOpen(false);
    if(groups[0].users.length > 0){
      alert("You cannot have unsorted students")
      return;
    }
    groups.shift();

    setLoading(true);

    await axios.post(`${process.env.REACT_APP_API_HOST}/api/groups/finalizeGroups/${selectedClass}`, 
    {class_id : selectedClass, groups: groups},
    {
      headers: {Authorization: `Bearer ${state.token.access_token}`},
    })   
    await axios.put(`${process.env.REACT_APP_API_HOST}/api/semester/updateGroups`, 
    {
      headers: {Authorization: `Bearer ${state.token.access_token}`},
    })   

    navigate('/classview',{
      state: {
        token: state.token,
        class_id: state.class_id,
        department: state.department,
        name: state.name,
        startSemester: state.startSemester,
        year: state.year
    }  }
) 
  }
  const handleConfirmFinalizeGroups = () => {
    setConfirmOpen(true);
  }

  const handleExportGroups = () => {
      axios.get(`${process.env.REACT_APP_API_HOST}/api/csv/groupsCSV/${state.class_id}`,
      {
        headers: {Authorization: `Bearer ${state.token.access_token}`},
      })
      .then(res => res.data)
      .then(data => {             
          let csvContent = "data:text/csv;charset=utf-8,";
          csvContent += "name, canvas_user_id, user_id, login_id, sections, group_name, canvas_group_id, group_id \r\n";
          data.students.forEach(function(rowArray) {
            let row = 
              '\"' + rowArray.last_name+', '+ rowArray.first_name + '\",' +
              rowArray.canvas_id + "," + 
              rowArray.ucf_id + "," +
              rowArray.canvas_username + "," + 
              rowArray.section + "," + 
              rowArray.project_name + ",";
            csvContent += row + "\r\n";
          });
  
          var encodedUri = encodeURI(csvContent);
          var link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute("download", "Project_Teams.csv");
          document.body.appendChild(link); // include in page
          
          link.click();
          
      })
      .catch(err => console.log(err))

  }

  const handleLockList = (isLocked, student, user_id, project_id) => {
    if (!isLocked){
      let item = {};
      item.user_id = student.user_id;
      item.project_id = project_id;
      lockedList.push(item);
    } else {
      var index;
      lockedList.map((user, i) => {
        if(user.user_id === student.user_id){
          index = i;
        }
      })
      lockedList.splice(index, 1);
    }
  }

  const handleLockAll = () => {

    groups.map((group) => {
      if(group.users.length !== 0){
        group.users.map(user => {
          if(!lockedList.find(item => item.user_id === user.user_id) && group.project_id !== 0) {
            let item = {};
            item.user_id = user.user_id;
            item.project_id = group.project_id;
            setLockedList(prev => {return([...prev, item])})
          }
        })
      }
    })
  }
  const handleUnlockAll = () => {
    setLockedList([]);
  }
  
  const handleDelete = async(run) => {
    setSavedRunsData(savedRunsData.filter((data) => data !== run))
    await axios.post(`${process.env.REACT_APP_API_HOST}/api/groups/deleteRun`, { run }, 
    {
      headers: {Authorization: `Bearer ${state.token.access_token}`}
    });
  }

  useEffect(() => {
    loadPageData();
  }, []);

  return (
    <Box>
      <DashboardNavbar userType="admin"/>
      {loading ? <LoadingModal open={loading} handleClose={() => setLoading(false)} />
      :<>
        {/* <Typography variant='h4' style={{marginLeft: 16, marginTop: 16}}>Group Formation</Typography> */}
        <Grid container style={{ maxWidth: "100%", margin: 0 }}>
          <Grid item xs={4} md={3} lg={3} xl={3}>
            <GroupStats
              handleRunAlgorithm={handleRunAlgorithm}
              handleSortByFirstChoice={handleSortByFirstChoice}
              handleFinalizeGroups={handleConfirmFinalizeGroups}
              handleExportGroups={handleExportGroups}
              handleExpandAll={handleExpandAll}
              handleCollapseAll={handleCollapseAll}
              handleLockAll={handleLockAll}
              handleUnlockAll={handleUnlockAll}
              openSavedList={handleOpenSavedList}
              openSaveModal={() => setShowSaveModal(true)}
              studentDetails={studentDetails}
              stats={stats}
            />
          </Grid>
          <Grid item xs={8} md={9} lg={9} xl={9}>
            <GroupsList
              completed={completed} 
              incomplete={incomplete}
              groups={groups}
              class_id={state.class_id}
              studentDetails={studentDetails}
              studentRankings={studentRankings}
              projectRankings={projectRankings}
              handleLockList={handleLockList}
              expandAll={expandAll}
              setExpandAll={setExpandAll}
              lockedList={lockedList}
              token={state.token}
            />
            <SavedRunModal saveGroups={saveGroups} open={showSaveModal} handleClose={() => setShowSaveModal(false)} />
            <SavedGroupFormationModal
              open={showSavedList}
              handleClose={() => setShowSavedList(false)}
              class_id={selectedClass}
              savedGroupFormations={savedRunsData}
              loadSavedGroups={loadSavedGroups}
              deleteSavedData={handleDelete}
            />
            <ConfirmModal
              open={confirmOpen} 
              message={"Finalize Groups"}
              handleClose={event => { event.stopPropagation(); setConfirmOpen(false); }} 
              content={"Are you sure you want to finalize these groups? These will be the final groups assigned to the class."} 
              handleFunction={handleFinalizeGroups} 
            />
          </Grid>
        </Grid>
      </>
      }
    </Box>
  )
}

export default GroupFormation;
